module.exports = __webpack_public_path__ + "img/RuiAn.d4d2a7ae.png";